import { Box, Link, Typography } from "@mui/material";

const tNoContactInformation = "No contact information";

export interface PhoneAndEmailRendererProps {
  email?: string | null;
  phoneNumber?: string | null;
}

export const PhoneAndEmailRenderer = ({ email, phoneNumber }: PhoneAndEmailRendererProps) => {
  if (!email && !phoneNumber) {
    return (
      <Typography color="text.disabled" fontStyle="italic">
        {tNoContactInformation}
      </Typography>
    );
  }

  return (
    <Box display="grid" gap="0.25rem" gridAutoFlow="row">
      {email && (
        <Link display="block" href={`mailto:${email}`}>
          {email}
        </Link>
      )}
      {phoneNumber && (
        <Link display="block" href={`tel:${phoneNumber}`}>
          {phoneNumber}
        </Link>
      )}
    </Box>
  );
};
